import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/admin_users_role_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  admin_user_email_cont: {
    model_name: 'AdminUser',
    column_type: 'string',
    column_name: 'email',
  },
  role_kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'custom'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
}
export const formColumnsConfig = {
  'self': {
    'role_id': { required: true, disabledUpdate: false },
    'admin_user_attributes': { required: true, disabledUpdate: true },
  },
  'admin_user_attributes': {
    'email': { required: true, disabledUpdate: true },
    'password': { required: true, disabledUpdate: true },
    'password_confirmation': { required: true, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('AdminUsersRole', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('AdminUsersRole', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
